import { Component } from '@angular/core';

@Component({
  selector: 'app-loan-agreement',
  templateUrl: './loan-agreement.component.html',
  styleUrls: ['./loan-agreement.component.scss'],
})
export class LoanAgreementComponent {}
